<template>
  <div class="loading-overlay">
    <div class="logo-wrapper">
      <img class="loading-logo" src="@/assets/loading.png" alt="logo" />
      <span class="loading-beam"></span>
    </div>
    <div class="loading-text-wrapper">
      <span class="loading-text"></span>
      <span class="loading-beam"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  z-index: 9999;
  inset: 0;
  background: radial-gradient(ellipse at 50% 40%, #18539c 60%, #0d274b 100%);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo-wrapper, .loading-text-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-logo {
  width: 120px;
  object-fit: contain;
  filter: drop-shadow(0 0 32px #fff) drop-shadow(0 0 64px #18539c);
  background: transparent;
  z-index: 1;
  pointer-events: none;
  animation: logo-breath 2.8s ease-in-out infinite;
}

@keyframes logo-breath {
  0%, 100% { filter: drop-shadow(0 0 32px #fff) drop-shadow(0 0 64px #18539c) brightness(1); }
  50% { filter: drop-shadow(0 0 40px #fff) drop-shadow(0 0 80px #18539c) brightness(1.08); }
}

.loading-text-wrapper {
  margin-top: 22px;
}

.loading-text {
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  letter-spacing: 4px;
  text-shadow:
    0 0 8px #fff,
    0 0 16px #18539c,
    0 0 32px #18539c;
  z-index: 1;
  position: relative;
  pointer-events: none;
  animation: text-breath 2.8s ease-in-out infinite;
}

@keyframes text-breath {
  0%, 100% { text-shadow: 0 0 8px #fff, 0 0 16px #18539c, 0 0 32px #18539c; }
  50% { text-shadow: 0 0 16px #fff, 0 0 32px #18539c, 0 0 48px #18539c; }
}

.loading-beam {
  position: absolute;
  top: 0;
  left: -90%;
  width: 90%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
  background: 
    linear-gradient(
      120deg,
      rgba(255,255,255,0) 0%,
      rgba(255,255,255,0.10) 35%,
      rgba(255,255,255,0.22) 48%,
      rgba(255,255,255,0.38) 50%,
      rgba(24,83,156,0.13) 55%,
      rgba(255,255,255,0.10) 60%,
      rgba(255,255,255,0) 100%
    );
  filter: blur(6px);
  opacity: 0.0;
  animation: sweep 2.1s cubic-bezier(0.4,0,0.2,1) infinite, beam-rotate 2.1s linear infinite;
}

@keyframes sweep {
  0% {
    left: -90%;
    opacity: 0;
    width: 80%;
  }
  10% {
    opacity: 0.10;
    width: 90%;
  }
  30% {
    opacity: 0.32;
    width: 100%;
  }
  50% {
    opacity: 0.48;
    width: 110%;
  }
  70% {
    opacity: 0.32;
    width: 100%;
  }
  90% {
    opacity: 0.10;
    width: 90%;
  }
  100% {
    left: 120%;
    opacity: 0;
    width: 80%;
  }
}

@keyframes beam-rotate {
  0% { transform: skewX(-18deg) rotate(-2deg);}
  50% { transform: skewX(-22deg) rotate(2deg);}
  100% { transform: skewX(-18deg) rotate(-2deg);}
}
</style>